import React from 'react'
import { Link } from 'react-router-dom'
import ForgotPasswordForm from '../../../components/Authentication/ForgotPasswordForm'
import { Helmet } from 'react-helmet'

export default function IndexForgotPassword() {

    // useEffect(() => {
    //     // Mettre à jour le titre de la page
    //     document.title = "Mot de passe oublié - Events";
        
    // }, []);

    return (
        <>
            <Helmet>
                <title>Mot de Passe Oublié - Réinitialisez votre Compte Organisateur | Events CI</title>

                <meta
                name="description"
                content="Vous avez oublié votre mot de passe sur Events ? Réinitialisez-le facilement grâce à votre adresse e-mail. Accédez à votre espace organisateur en quelques clics."
                />

                <meta
                name="keywords"
                content="mot de passe oublié Events, réinitialiser mot de passe, connexion organisateur CI, récupérer compte événementiel, plateforme billetterie Côte d'Ivoire"
                />

                <meta name="author" content="Events" />

                {/* Open Graph */}
                <meta property="og:title" content="Mot de Passe Oublié - Réinitialisez votre Compte Organisateur | Events CI" />
                <meta
                property="og:description"
                content="Vous avez oublié votre mot de passe sur Events ? Réinitialisez-le facilement grâce à votre adresse e-mail. Accédez à votre espace organisateur en quelques clics."
                />
                <meta property="og:image" content="https://eventsbilletterie.com/assets/images/facadeEvents.png" />
                <meta property="og:url" content="https://eventsbilletterie.com/forgot-password" />
                <meta property="og:type" content="website" />

                {/* Twitter Card */}
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="Mot de Passe Oublié - Réinitialisez votre Compte Organisateur | Events CI" />
                <meta
                name="twitter:description"
                content="Vous avez oublié votre mot de passe sur Events ? Réinitialisez-le facilement grâce à votre adresse e-mail. Accédez à votre espace organisateur en quelques clics."
                />
                <meta name="twitter:image" content="https://eventsbilletterie.com/assets/images/facadeEvents.png" />
                <meta name="twitter:site" content="@events_billetterie" /> {/* Remplace par ton handle Twitter si applicable */}

                {/* Canonical URL */}
                <link rel="canonical" href="https://eventsbilletterie.com/forgot-password" />
            </Helmet>
            
            <div className="nc-PageLogin " data-nc-id="PageLogin">
                <div className="container mb-24 lg:mb-32">
                    <h2 className="my-10 mb-5 flex items-center text-2xl leading-[115%] md:text-3xl md:leading-[115%] font-bold text-neutral-900 dark:text-neutral-100 justify-center">
                        Mot de passe oublié !
                    </h2>
                    <div className="relative text-center max-w-md mx-auto space-y-11">
                        <span className="relative inline-block px-4 text-sm bg-white dark:text-neutral-400 dark:bg-neutral-900">
                            Veuillez saisir l'adresse e-mail lié à votre compte afin de le réinitialiser.
                        </span>
                    </div>
                    <div className="max-w-md mx-auto space-y-6 mt-12">
                    
                        <ForgotPasswordForm />
                        <span className="block text-center text-neutral-700 dark:text-neutral-300">
                            Vous avez déjà un compte?{' '} <Link to="/login" className='font-medium text-primary-6000'>Connectez-vous ici</Link>
                        </span>
                    </div>
                </div>
            </div>
        </>
    )
}
